/** ITU-T E.164 country calling codes. `iso` is unique; `code` may be shared. */
export const CountryCode = [
  { iso: 'IN', code: '+91', label: 'India', flag: '🇮🇳' },
  { iso: 'AF', code: '+93', label: 'Afghanistan', flag: '🇦🇫' },
  { iso: 'AL', code: '+355', label: 'Albania', flag: '🇦🇱' },
  { iso: 'DZ', code: '+213', label: 'Algeria', flag: '🇩🇿' },
  { iso: 'AS', code: '+1684', label: 'American Samoa', flag: '🇦🇸' },
  { iso: 'AD', code: '+376', label: 'Andorra', flag: '🇦🇩' },
  { iso: 'AO', code: '+244', label: 'Angola', flag: '🇦🇴' },
  { iso: 'AI', code: '+1264', label: 'Anguilla', flag: '🇦🇮' },
  { iso: 'AG', code: '+1268', label: 'Antigua and Barbuda', flag: '🇦🇬' },
  { iso: 'AR', code: '+54', label: 'Argentina', flag: '🇦🇷' },
  { iso: 'AM', code: '+374', label: 'Armenia', flag: '🇦🇲' },
  { iso: 'AW', code: '+297', label: 'Aruba', flag: '🇦🇼' },
  { iso: 'AU', code: '+61', label: 'Australia', flag: '🇦🇺' },
  { iso: 'AT', code: '+43', label: 'Austria', flag: '🇦🇹' },
  { iso: 'AZ', code: '+994', label: 'Azerbaijan', flag: '🇦🇿' },
  { iso: 'BS', code: '+1242', label: 'Bahamas', flag: '🇧🇸' },
  { iso: 'BH', code: '+973', label: 'Bahrain', flag: '🇧🇭' },
  { iso: 'BD', code: '+880', label: 'Bangladesh', flag: '🇧🇩' },
  { iso: 'BB', code: '+1246', label: 'Barbados', flag: '🇧🇧' },
  { iso: 'BY', code: '+375', label: 'Belarus', flag: '🇧🇾' },
  { iso: 'BE', code: '+32', label: 'Belgium', flag: '🇧🇪' },
  { iso: 'BZ', code: '+501', label: 'Belize', flag: '🇧🇿' },
  { iso: 'BJ', code: '+229', label: 'Benin', flag: '🇧🇯' },
  { iso: 'BM', code: '+1441', label: 'Bermuda', flag: '🇧🇲' },
  { iso: 'BT', code: '+975', label: 'Bhutan', flag: '🇧🇹' },
  { iso: 'BO', code: '+591', label: 'Bolivia', flag: '🇧🇴' },
  { iso: 'BA', code: '+387', label: 'Bosnia and Herzegovina', flag: '🇧🇦' },
  { iso: 'BW', code: '+267', label: 'Botswana', flag: '🇧🇼' },
  { iso: 'BR', code: '+55', label: 'Brazil', flag: '🇧🇷' },
  { iso: 'IO', code: '+246', label: 'British Indian Ocean Territory', flag: '🇮🇴' },
  { iso: 'VG', code: '+1284', label: 'British Virgin Islands', flag: '🇻🇬' },
  { iso: 'BN', code: '+673', label: 'Brunei', flag: '🇧🇳' },
  { iso: 'BG', code: '+359', label: 'Bulgaria', flag: '🇧🇬' },
  { iso: 'BF', code: '+226', label: 'Burkina Faso', flag: '🇧🇫' },
  { iso: 'BI', code: '+257', label: 'Burundi', flag: '🇧🇮' },
  { iso: 'KH', code: '+855', label: 'Cambodia', flag: '🇰🇭' },
  { iso: 'CM', code: '+237', label: 'Cameroon', flag: '🇨🇲' },
  { iso: 'CA', code: '+1', label: 'Canada', flag: '🇨🇦' },
  { iso: 'CV', code: '+238', label: 'Cape Verde', flag: '🇨🇻' },
  { iso: 'KY', code: '+1345', label: 'Cayman Islands', flag: '🇰🇾' },
  { iso: 'CF', code: '+236', label: 'Central African Republic', flag: '🇨🇫' },
  { iso: 'TD', code: '+235', label: 'Chad', flag: '🇹🇩' },
  { iso: 'CL', code: '+56', label: 'Chile', flag: '🇨🇱' },
  { iso: 'CN', code: '+86', label: 'China', flag: '🇨🇳' },
  { iso: 'CX', code: '+61', label: 'Christmas Island', flag: '🇨🇽' },
  { iso: 'CC', code: '+61', label: 'Cocos Islands', flag: '🇨🇨' },
  { iso: 'CO', code: '+57', label: 'Colombia', flag: '🇨🇴' },
  { iso: 'KM', code: '+269', label: 'Comoros', flag: '🇰🇲' },
  { iso: 'CG', code: '+242', label: 'Congo', flag: '🇨🇬' },
  { iso: 'CD', code: '+243', label: 'Congo (DRC)', flag: '🇨🇩' },
  { iso: 'CK', code: '+682', label: 'Cook Islands', flag: '🇨🇰' },
  { iso: 'CR', code: '+506', label: 'Costa Rica', flag: '🇨🇷' },
  { iso: 'CI', code: '+225', label: 'Côte d’Ivoire', flag: '🇨🇮' },
  { iso: 'HR', code: '+385', label: 'Croatia', flag: '🇭🇷' },
  { iso: 'CU', code: '+53', label: 'Cuba', flag: '🇨🇺' },
  { iso: 'CW', code: '+599', label: 'Curaçao', flag: '🇨🇼' },
  { iso: 'CY', code: '+357', label: 'Cyprus', flag: '🇨🇾' },
  { iso: 'CZ', code: '+420', label: 'Czech Republic', flag: '🇨🇿' },
  { iso: 'DK', code: '+45', label: 'Denmark', flag: '🇩🇰' },
  { iso: 'DJ', code: '+253', label: 'Djibouti', flag: '🇩🇯' },
  { iso: 'DM', code: '+1767', label: 'Dominica', flag: '🇩🇲' },
  { iso: 'DO', code: '+1809', label: 'Dominican Republic', flag: '🇩🇴' },
  { iso: 'EC', code: '+593', label: 'Ecuador', flag: '🇪🇨' },
  { iso: 'EG', code: '+20', label: 'Egypt', flag: '🇪🇬' },
  { iso: 'SV', code: '+503', label: 'El Salvador', flag: '🇸🇻' },
  { iso: 'GQ', code: '+240', label: 'Equatorial Guinea', flag: '🇬🇶' },
  { iso: 'ER', code: '+291', label: 'Eritrea', flag: '🇪🇷' },
  { iso: 'EE', code: '+372', label: 'Estonia', flag: '🇪🇪' },
  { iso: 'SZ', code: '+268', label: 'Eswatini', flag: '🇸🇿' },
  { iso: 'ET', code: '+251', label: 'Ethiopia', flag: '🇪🇹' },
  { iso: 'FK', code: '+500', label: 'Falkland Islands', flag: '🇫🇰' },
  { iso: 'FO', code: '+298', label: 'Faroe Islands', flag: '🇫🇴' },
  { iso: 'FJ', code: '+679', label: 'Fiji', flag: '🇫🇯' },
  { iso: 'FI', code: '+358', label: 'Finland', flag: '🇫🇮' },
  { iso: 'FR', code: '+33', label: 'France', flag: '🇫🇷' },
  { iso: 'GF', code: '+594', label: 'French Guiana', flag: '🇬🇫' },
  { iso: 'PF', code: '+689', label: 'French Polynesia', flag: '🇵🇫' },
  { iso: 'GA', code: '+241', label: 'Gabon', flag: '🇬🇦' },
  { iso: 'GM', code: '+220', label: 'Gambia', flag: '🇬🇲' },
  { iso: 'GE', code: '+995', label: 'Georgia', flag: '🇬🇪' },
  { iso: 'DE', code: '+49', label: 'Germany', flag: '🇩🇪' },
  { iso: 'GH', code: '+233', label: 'Ghana', flag: '🇬🇭' },
  { iso: 'GI', code: '+350', label: 'Gibraltar', flag: '🇬🇮' },
  { iso: 'GR', code: '+30', label: 'Greece', flag: '🇬🇷' },
  { iso: 'GL', code: '+299', label: 'Greenland', flag: '🇬🇱' },
  { iso: 'GD', code: '+1473', label: 'Grenada', flag: '🇬🇩' },
  { iso: 'GP', code: '+590', label: 'Guadeloupe', flag: '🇬🇵' },
  { iso: 'GU', code: '+1671', label: 'Guam', flag: '🇬🇺' },
  { iso: 'GT', code: '+502', label: 'Guatemala', flag: '🇬🇹' },
  { iso: 'GG', code: '+44', label: 'Guernsey', flag: '🇬🇬' },
  { iso: 'GN', code: '+224', label: 'Guinea', flag: '🇬🇳' },
  { iso: 'GW', code: '+245', label: 'Guinea-Bissau', flag: '🇬🇼' },
  { iso: 'GY', code: '+592', label: 'Guyana', flag: '🇬🇾' },
  { iso: 'HT', code: '+509', label: 'Haiti', flag: '🇭🇹' },
  { iso: 'HN', code: '+504', label: 'Honduras', flag: '🇭🇳' },
  { iso: 'HK', code: '+852', label: 'Hong Kong', flag: '🇭🇰' },
  { iso: 'HU', code: '+36', label: 'Hungary', flag: '🇭🇺' },
  { iso: 'IS', code: '+354', label: 'Iceland', flag: '🇮🇸' },
  { iso: 'ID', code: '+62', label: 'Indonesia', flag: '🇮🇩' },
  { iso: 'IR', code: '+98', label: 'Iran', flag: '🇮🇷' },
  { iso: 'IQ', code: '+964', label: 'Iraq', flag: '🇮🇶' },
  { iso: 'IE', code: '+353', label: 'Ireland', flag: '🇮🇪' },
  { iso: 'IM', code: '+44', label: 'Isle of Man', flag: '🇮🇲' },
  { iso: 'IL', code: '+972', label: 'Israel', flag: '🇮🇱' },
  { iso: 'IT', code: '+39', label: 'Italy', flag: '🇮🇹' },
  { iso: 'JM', code: '+1876', label: 'Jamaica', flag: '🇯🇲' },
  { iso: 'JP', code: '+81', label: 'Japan', flag: '🇯🇵' },
  { iso: 'JE', code: '+44', label: 'Jersey', flag: '🇯🇪' },
  { iso: 'JO', code: '+962', label: 'Jordan', flag: '🇯🇴' },
  { iso: 'KZ', code: '+7', label: 'Kazakhstan', flag: '🇰🇿' },
  { iso: 'KE', code: '+254', label: 'Kenya', flag: '🇰🇪' },
  { iso: 'KI', code: '+686', label: 'Kiribati', flag: '🇰🇮' },
  { iso: 'XK', code: '+383', label: 'Kosovo', flag: '🇽🇰' },
  { iso: 'KW', code: '+965', label: 'Kuwait', flag: '🇰🇼' },
  { iso: 'KG', code: '+996', label: 'Kyrgyzstan', flag: '🇰🇬' },
  { iso: 'LA', code: '+856', label: 'Laos', flag: '🇱🇦' },
  { iso: 'LV', code: '+371', label: 'Latvia', flag: '🇱🇻' },
  { iso: 'LB', code: '+961', label: 'Lebanon', flag: '🇱🇧' },
  { iso: 'LS', code: '+266', label: 'Lesotho', flag: '🇱🇸' },
  { iso: 'LR', code: '+231', label: 'Liberia', flag: '🇱🇷' },
  { iso: 'LY', code: '+218', label: 'Libya', flag: '🇱🇾' },
  { iso: 'LI', code: '+423', label: 'Liechtenstein', flag: '🇱🇮' },
  { iso: 'LT', code: '+370', label: 'Lithuania', flag: '🇱🇹' },
  { iso: 'LU', code: '+352', label: 'Luxembourg', flag: '🇱🇺' },
  { iso: 'MO', code: '+853', label: 'Macao', flag: '🇲🇴' },
  { iso: 'MG', code: '+261', label: 'Madagascar', flag: '🇲🇬' },
  { iso: 'MW', code: '+265', label: 'Malawi', flag: '🇲🇼' },
  { iso: 'MY', code: '+60', label: 'Malaysia', flag: '🇲🇾' },
  { iso: 'MV', code: '+960', label: 'Maldives', flag: '🇲🇻' },
  { iso: 'ML', code: '+223', label: 'Mali', flag: '🇲🇱' },
  { iso: 'MT', code: '+356', label: 'Malta', flag: '🇲🇹' },
  { iso: 'MH', code: '+692', label: 'Marshall Islands', flag: '🇲🇭' },
  { iso: 'MQ', code: '+596', label: 'Martinique', flag: '🇲🇶' },
  { iso: 'MR', code: '+222', label: 'Mauritania', flag: '🇲🇷' },
  { iso: 'MU', code: '+230', label: 'Mauritius', flag: '🇲🇺' },
  { iso: 'YT', code: '+262', label: 'Mayotte', flag: '🇾🇹' },
  { iso: 'MX', code: '+52', label: 'Mexico', flag: '🇲🇽' },
  { iso: 'FM', code: '+691', label: 'Micronesia', flag: '🇫🇲' },
  { iso: 'MD', code: '+373', label: 'Moldova', flag: '🇲🇩' },
  { iso: 'MC', code: '+377', label: 'Monaco', flag: '🇲🇨' },
  { iso: 'MN', code: '+976', label: 'Mongolia', flag: '🇲🇳' },
  { iso: 'ME', code: '+382', label: 'Montenegro', flag: '🇲🇪' },
  { iso: 'MS', code: '+1664', label: 'Montserrat', flag: '🇲🇸' },
  { iso: 'MA', code: '+212', label: 'Morocco', flag: '🇲🇦' },
  { iso: 'MZ', code: '+258', label: 'Mozambique', flag: '🇲🇿' },
  { iso: 'MM', code: '+95', label: 'Myanmar', flag: '🇲🇲' },
  { iso: 'NA', code: '+264', label: 'Namibia', flag: '🇳🇦' },
  { iso: 'NR', code: '+674', label: 'Nauru', flag: '🇳🇷' },
  { iso: 'NP', code: '+977', label: 'Nepal', flag: '🇳🇵' },
  { iso: 'NL', code: '+31', label: 'Netherlands', flag: '🇳🇱' },
  { iso: 'NC', code: '+687', label: 'New Caledonia', flag: '🇳🇨' },
  { iso: 'NZ', code: '+64', label: 'New Zealand', flag: '🇳🇿' },
  { iso: 'NI', code: '+505', label: 'Nicaragua', flag: '🇳🇮' },
  { iso: 'NE', code: '+227', label: 'Niger', flag: '🇳🇪' },
  { iso: 'NG', code: '+234', label: 'Nigeria', flag: '🇳🇬' },
  { iso: 'NU', code: '+683', label: 'Niue', flag: '🇳🇺' },
  { iso: 'NF', code: '+672', label: 'Norfolk Island', flag: '🇳🇫' },
  { iso: 'KP', code: '+850', label: 'North Korea', flag: '🇰🇵' },
  { iso: 'MK', code: '+389', label: 'North Macedonia', flag: '🇲🇰' },
  { iso: 'MP', code: '+1670', label: 'Northern Mariana Islands', flag: '🇲🇵' },
  { iso: 'NO', code: '+47', label: 'Norway', flag: '🇳🇴' },
  { iso: 'OM', code: '+968', label: 'Oman', flag: '🇴🇲' },
  { iso: 'PK', code: '+92', label: 'Pakistan', flag: '🇵🇰' },
  { iso: 'PW', code: '+680', label: 'Palau', flag: '🇵🇼' },
  { iso: 'PS', code: '+970', label: 'Palestine', flag: '🇵🇸' },
  { iso: 'PA', code: '+507', label: 'Panama', flag: '🇵🇦' },
  { iso: 'PG', code: '+675', label: 'Papua New Guinea', flag: '🇵🇬' },
  { iso: 'PY', code: '+595', label: 'Paraguay', flag: '🇵🇾' },
  { iso: 'PE', code: '+51', label: 'Peru', flag: '🇵🇪' },
  { iso: 'PH', code: '+63', label: 'Philippines', flag: '🇵🇭' },
  { iso: 'PL', code: '+48', label: 'Poland', flag: '🇵🇱' },
  { iso: 'PT', code: '+351', label: 'Portugal', flag: '🇵🇹' },
  { iso: 'PR', code: '+1787', label: 'Puerto Rico', flag: '🇵🇷' },
  { iso: 'QA', code: '+974', label: 'Qatar', flag: '🇶🇦' },
  { iso: 'RE', code: '+262', label: 'Réunion', flag: '🇷🇪' },
  { iso: 'RO', code: '+40', label: 'Romania', flag: '🇷🇴' },
  { iso: 'RU', code: '+7', label: 'Russia', flag: '🇷🇺' },
  { iso: 'RW', code: '+250', label: 'Rwanda', flag: '🇷🇼' },
  { iso: 'BL', code: '+590', label: 'Saint Barthélemy', flag: '🇧🇱' },
  { iso: 'SH', code: '+290', label: 'Saint Helena', flag: '🇸🇭' },
  { iso: 'KN', code: '+1869', label: 'Saint Kitts and Nevis', flag: '🇰🇳' },
  { iso: 'LC', code: '+1758', label: 'Saint Lucia', flag: '🇱🇨' },
  { iso: 'MF', code: '+590', label: 'Saint Martin', flag: '🇲🇫' },
  { iso: 'PM', code: '+508', label: 'Saint Pierre and Miquelon', flag: '🇵🇲' },
  { iso: 'VC', code: '+1784', label: 'Saint Vincent and the Grenadines', flag: '🇻🇨' },
  { iso: 'WS', code: '+685', label: 'Samoa', flag: '🇼🇸' },
  { iso: 'SM', code: '+378', label: 'San Marino', flag: '🇸🇲' },
  { iso: 'ST', code: '+239', label: 'São Tomé and Príncipe', flag: '🇸🇹' },
  { iso: 'SA', code: '+966', label: 'Saudi Arabia', flag: '🇸🇦' },
  { iso: 'SN', code: '+221', label: 'Senegal', flag: '🇸🇳' },
  { iso: 'RS', code: '+381', label: 'Serbia', flag: '🇷🇸' },
  { iso: 'SC', code: '+248', label: 'Seychelles', flag: '🇸🇨' },
  { iso: 'SL', code: '+232', label: 'Sierra Leone', flag: '🇸🇱' },
  { iso: 'SG', code: '+65', label: 'Singapore', flag: '🇸🇬' },
  { iso: 'SX', code: '+1721', label: 'Sint Maarten', flag: '🇸🇽' },
  { iso: 'SK', code: '+421', label: 'Slovakia', flag: '🇸🇰' },
  { iso: 'SI', code: '+386', label: 'Slovenia', flag: '🇸🇮' },
  { iso: 'SB', code: '+677', label: 'Solomon Islands', flag: '🇸🇧' },
  { iso: 'SO', code: '+252', label: 'Somalia', flag: '🇸🇴' },
  { iso: 'ZA', code: '+27', label: 'South Africa', flag: '🇿🇦' },
  { iso: 'KR', code: '+82', label: 'South Korea', flag: '🇰🇷' },
  { iso: 'SS', code: '+211', label: 'South Sudan', flag: '🇸🇸' },
  { iso: 'ES', code: '+34', label: 'Spain', flag: '🇪🇸' },
  { iso: 'LK', code: '+94', label: 'Sri Lanka', flag: '🇱🇰' },
  { iso: 'SD', code: '+249', label: 'Sudan', flag: '🇸🇩' },
  { iso: 'SR', code: '+597', label: 'Suriname', flag: '🇸🇷' },
  { iso: 'SE', code: '+46', label: 'Sweden', flag: '🇸🇪' },
  { iso: 'CH', code: '+41', label: 'Switzerland', flag: '🇨🇭' },
  { iso: 'SY', code: '+963', label: 'Syria', flag: '🇸🇾' },
  { iso: 'TW', code: '+886', label: 'Taiwan', flag: '🇹🇼' },
  { iso: 'TJ', code: '+992', label: 'Tajikistan', flag: '🇹🇯' },
  { iso: 'TZ', code: '+255', label: 'Tanzania', flag: '🇹🇿' },
  { iso: 'TH', code: '+66', label: 'Thailand', flag: '🇹🇭' },
  { iso: 'TL', code: '+670', label: 'Timor-Leste', flag: '🇹🇱' },
  { iso: 'TG', code: '+228', label: 'Togo', flag: '🇹🇬' },
  { iso: 'TK', code: '+690', label: 'Tokelau', flag: '🇹🇰' },
  { iso: 'TO', code: '+676', label: 'Tonga', flag: '🇹🇴' },
  { iso: 'TT', code: '+1868', label: 'Trinidad and Tobago', flag: '🇹🇹' },
  { iso: 'TN', code: '+216', label: 'Tunisia', flag: '🇹🇳' },
  { iso: 'TR', code: '+90', label: 'Turkey', flag: '🇹🇷' },
  { iso: 'TM', code: '+993', label: 'Turkmenistan', flag: '🇹🇲' },
  { iso: 'TC', code: '+1649', label: 'Turks and Caicos Islands', flag: '🇹🇨' },
  { iso: 'TV', code: '+688', label: 'Tuvalu', flag: '🇹🇻' },
  { iso: 'VI', code: '+1340', label: 'U.S. Virgin Islands', flag: '🇻🇮' },
  { iso: 'UG', code: '+256', label: 'Uganda', flag: '🇺🇬' },
  { iso: 'UA', code: '+380', label: 'Ukraine', flag: '🇺🇦' },
  { iso: 'AE', code: '+971', label: 'United Arab Emirates', flag: '🇦🇪' },
  { iso: 'GB', code: '+44', label: 'United Kingdom', flag: '🇬🇧' },
  { iso: 'US', code: '+1', label: 'United States', flag: '🇺🇸' },
  { iso: 'UY', code: '+598', label: 'Uruguay', flag: '🇺🇾' },
  { iso: 'UZ', code: '+998', label: 'Uzbekistan', flag: '🇺🇿' },
  { iso: 'VU', code: '+678', label: 'Vanuatu', flag: '🇻🇺' },
  { iso: 'VA', code: '+39', label: 'Vatican City', flag: '🇻🇦' },
  { iso: 'VE', code: '+58', label: 'Venezuela', flag: '🇻🇪' },
  { iso: 'VN', code: '+84', label: 'Vietnam', flag: '🇻🇳' },
  { iso: 'WF', code: '+681', label: 'Wallis and Futuna', flag: '🇼🇫' },
  { iso: 'YE', code: '+967', label: 'Yemen', flag: '🇾🇪' },
  { iso: 'ZM', code: '+260', label: 'Zambia', flag: '🇿🇲' },
  { iso: 'ZW', code: '+263', label: 'Zimbabwe', flag: '🇿🇼' },
];

export const DEFAULT_COUNTRY_ISO = 'IN';

export const getCountryByIso = (iso) =>
  CountryCode.find((country) => country.iso === iso) || CountryCode[0];

/** National number max length so E.164 stays within 15 digits. */
export const getNationalMaxLength = (dialCode) => {
  const countryDigits = String(dialCode || '').replace(/\D/g, '').length;
  return Math.max(4, 15 - countryDigits);
};
